module.exports = __webpack_public_path__ + "static/media/Aniel.950dcd8d.png";